/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Dropdown, DropdownItem } from '@tradingblock/components';

interface LinkBlockDropdownProps {
  handleTradeClick: () => void;
  handleExistingToggleClick: () => void;
  actionText: string;
  isLinked: boolean;
  orderBlocksExist: boolean;
}

export const LinkBlockDropdown: React.FunctionComponent<LinkBlockDropdownProps> = ({
  handleTradeClick,
  handleExistingToggleClick,
  actionText,
  isLinked,
  orderBlocksExist,
  children,
}) => {
  if (!orderBlocksExist || isLinked) {
    return <>{children}</>;
  }

  return (
    <Dropdown content={children} direction={'right'} buttonOptions={{ toggleButtonClassName: 'table-inline-btn' }}>
      {!isLinked && <DropdownItem onClick={handleTradeClick}>{actionText} in new block</DropdownItem>}
      {!isLinked && orderBlocksExist && (
        <DropdownItem onClick={handleExistingToggleClick}>Open in existing order&hellip;</DropdownItem>
      )}
    </Dropdown>
  );
};
